"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._fetchColocatedAgenda = exports._promoteSession = exports._deleteSession = exports._updateSession = exports._createSession = exports._fetchSelectedEventSessions = exports._reportSessionAction = exports._refetchSessionDiscussion = exports._postSessionComment = exports._watchSession = exports._removeSeatNative = exports._removeSeat = exports._reserveSeat = exports._rateSession = exports._unpinSession = exports._pinSession = exports._fetchZoomSignature = exports._fetchAgenda = void 0;
const api_1 = require("../../utils/api");
const base_1 = require("../../utils/base");
const _fetchAgenda = (basePath, token, eventId) => __awaiter(void 0, void 0, void 0, function* () {
    const base = (0, base_1.getBasePath)(basePath);
    const agenda = yield (0, api_1.getRequest)(`${base.EVENTS}/${eventId}/agenda`, token);
    return (agenda === null || agenda === void 0 ? void 0 : agenda.data) || agenda;
});
exports._fetchAgenda = _fetchAgenda;
const _fetchZoomSignature = (basePath, token, account, meetingId) => __awaiter(void 0, void 0, void 0, function* () {
    const base = (0, base_1.getBasePath)(basePath);
    const response = yield (0, api_1.getFormRequest)(base.ZOOM.SIGNATURE, token, {
        account,
    }, {
        meeting: meetingId,
    });
    return response === null || response === void 0 ? void 0 : response.signature;
});
exports._fetchZoomSignature = _fetchZoomSignature;
const _pinSession = (basePath, token, sessionId) => __awaiter(void 0, void 0, void 0, function* () {
    const base = (0, base_1.getBasePath)(basePath);
    return yield (0, api_1.getRequest)(`${base.SESSIONS}/${sessionId}/pin`, token);
});
exports._pinSession = _pinSession;
const _unpinSession = (basePath, token, sessionId) => __awaiter(void 0, void 0, void 0, function* () {
    const base = (0, base_1.getBasePath)(basePath);
    return yield (0, api_1.getRequest)(`${base.SESSIONS}/${sessionId}/unpin`, token);
});
exports._unpinSession = _unpinSession;
const _rateSession = (basePath, token, sessionId, body) => __awaiter(void 0, void 0, void 0, function* () {
    const base = (0, base_1.getBasePath)(basePath);
    return yield (0, api_1.postRequest)(`${base.SESSIONS}/${sessionId}/rate`, body, token);
});
exports._rateSession = _rateSession;
const _reserveSeat = (basePath, token, sessionId) => __awaiter(void 0, void 0, void 0, function* () {
    const base = (0, base_1.getBasePath)(basePath);
    return yield (0, api_1.getRequest)(`${base.SESSIONS}/${sessionId}/reserve`, token);
});
exports._reserveSeat = _reserveSeat;
const _removeSeat = (basePath, token, sessionId) => __awaiter(void 0, void 0, void 0, function* () {
    const base = (0, base_1.getBasePath)(basePath);
    return yield (0, api_1.deleteRequest)(`${base.SESSIONS}/${sessionId}/reserve`, {}, token);
});
exports._removeSeat = _removeSeat;
const _removeSeatNative = (basePath, token, sessionId) => __awaiter(void 0, void 0, void 0, function* () {
    const base = (0, base_1.getBasePath)(basePath);
    const response = yield (0, api_1.deleteRequest)(`${base.SESSIONS}/${sessionId}/reserve`, null, token);
    return response;
});
exports._removeSeatNative = _removeSeatNative;
const _watchSession = (basePath, token, sessionId) => __awaiter(void 0, void 0, void 0, function* () {
    const base = (0, base_1.getBasePath)(basePath);
    return yield (0, api_1.getRequest)(`${base.SESSIONS}/${sessionId}/watch`, token);
});
exports._watchSession = _watchSession;
const _postSessionComment = (basePath, token, sessionId, message) => __awaiter(void 0, void 0, void 0, function* () {
    const base = (0, base_1.getBasePath)(basePath);
    return yield (0, api_1.postRequest)(`${base.SESSIONS}/${sessionId}/comment`, { message }, token);
});
exports._postSessionComment = _postSessionComment;
const _refetchSessionDiscussion = (basePath, token, sessionId) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const base = (0, base_1.getBasePath)(basePath);
    const response = yield (0, api_1.getRequest)(`${base.SESSIONS}/${sessionId}/chat`, token);
    return ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data) || (response === null || response === void 0 ? void 0 : response.data) || response;
});
exports._refetchSessionDiscussion = _refetchSessionDiscussion;
const _reportSessionAction = (basePath, token, sessionId, requestData) => __awaiter(void 0, void 0, void 0, function* () {
    const base = (0, base_1.getBasePath)(basePath);
    const response = yield (0, api_1.postRequest)(`${base.ACTIONS_SESSIONS}/${sessionId}`, requestData, token);
    return response === null || response === void 0 ? void 0 : response.url;
});
exports._reportSessionAction = _reportSessionAction;
const _fetchSelectedEventSessions = (basePath, token, eventId) => __awaiter(void 0, void 0, void 0, function* () {
    const base = (0, base_1.getBasePath)(basePath);
    const eventSessions = yield (0, api_1.getRequest)(`${base.EVENTS}/${eventId}/sessions?not_published=0`, token);
    return (eventSessions === null || eventSessions === void 0 ? void 0 : eventSessions.data) || eventSessions;
});
exports._fetchSelectedEventSessions = _fetchSelectedEventSessions;
const _createSession = (basePath, token, data, files) => __awaiter(void 0, void 0, void 0, function* () {
    const base = (0, base_1.getBasePath)(basePath);
    const session = yield (0, api_1.postFilesAndDataRequest)(base.SESSIONS, data, files, token);
    return (session === null || session === void 0 ? void 0 : session.data) || session;
});
exports._createSession = _createSession;
const _updateSession = (basePath, token, sessionId, data, files) => __awaiter(void 0, void 0, void 0, function* () {
    const base = (0, base_1.getBasePath)(basePath);
    const session = yield (0, api_1.postFilesAndDataRequest)(`${base.SESSIONS}/${sessionId}`, data, files, token, "put");
    return (session === null || session === void 0 ? void 0 : session.data) || session;
});
exports._updateSession = _updateSession;
const _deleteSession = (basePath, token, sessionId) => __awaiter(void 0, void 0, void 0, function* () {
    const base = (0, base_1.getBasePath)(basePath);
    return yield (0, api_1.deleteRequest)(`${base.SESSIONS}/${sessionId}`, [], token);
});
exports._deleteSession = _deleteSession;
const _promoteSession = (basePath, token, sessionId, promotionDate) => __awaiter(void 0, void 0, void 0, function* () {
    const base = (0, base_1.getBasePath)(basePath);
    const session = yield (0, api_1.postFilesAndDataRequest)(`${base.SESSIONS}/${sessionId}/promote`, { promotion_date: promotionDate }, [], token);
    return session;
});
exports._promoteSession = _promoteSession;
const _fetchColocatedAgenda = (basePath, eventId) => __awaiter(void 0, void 0, void 0, function* () {
    const base = (0, base_1.getBasePath)(basePath);
    const agenda = yield (0, api_1.getRequest)(`${base.PUBLIC_EVENTS}/${eventId}/colocated-agenda`);
    return (agenda === null || agenda === void 0 ? void 0 : agenda.data) || agenda;
});
exports._fetchColocatedAgenda = _fetchColocatedAgenda;
